/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

@Injectable()
export class ErrorLogInterceptor implements HttpInterceptor {
  private ignoredEndPoints: Array<string> = [];

  constructor(private messageService: MessageService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const noNeedInterceptor: boolean = !!this.ignoredEndPoints.find(
      (endPoint) => {
        return request.url.includes(endPoint);
      },
    );

    if (noNeedInterceptor) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        // const errors: any = err.error?.errors || {};

        const msg: string =
          // this.getSubstring(this.getFirstValidationErrorFromErrors(errors)) ||
          this.getSubstring(err?.error?.error?.message) ||
          this.getSubstring(err?.error?.message) ||
          this.getSubstring(err?.message) ||
          'An Error occurred';

        this.messageService.add({
          severity: 'error',
          summary: `Error Code: ${err.status?.toString() ?? 500}`,
          detail: `${msg}`,
        });

        return throwError(() => err);
      }),
    );
  }

  private getSubstring(str: any | null | undefined): string | null {
    if (!str) {
      return null;
    }

    let subStr: string = JSON.stringify(str).substring(0, 100);

    if (subStr.length === 100) {
      subStr = `${subStr} ...`;
    }

    return subStr;
  }
}
